import { mixpanel } from '@/vendors/integrations'

export default class {
  static item = ({ name }) => {
    mixpanel.track('Clicked Menu item', {
      'Label': name
    })
  }
}
